import * as React from 'react'

type AmountInputProps = {
  value: number
  min: number
  max: number
  step: number
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export default function AmountInput({ value, min, max, step, onChange }: AmountInputProps) {
  return (
    <div className="text-center">
      <input
        className="form-control d-inline-block"
        type="number"
        // name="campaign[items_attributes][][amount]"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={onChange}
      />
    </div>
  )
}
